import { React, useState, useEffect } from "react";
import axios, { all } from "axios";
import PropTypes from "prop-types";
import {
  Multiselect,
  EnhancedAutocomplete,
  CreateValidateTextField,
  LocationAutocomplete,
} from "..";
import { Dialog, DialogTitle, FilledInput, Snackbar, Alert } from "@mui/material";
import { Title } from "@mui/icons-material";
function EventCreate(props) {
  const { userType, username, updateTable, setUpdateTable, membershipLvls } = props;

  //event fields
  const [eventTitle, setEventTitle] = useState("");
  const [description, setDescription] = useState("");
  const [minMembLvl, setMinMembLvl] = useState("");
  const [maxContacts, setMaxContacts] = useState(Array.from("0".repeat(membershipLvls.length)));
  const [allowedMembLvls, setAllowedMembLvls] = useState([]);

  //dates
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = (currentDate.getMonth() + 1).toString().padStart(2, "0"); // add 1 to month because getMonth() returns 0-based index, and pad with leading zero if necessary
  const currentDay = currentDate.getDate().toString().padStart(2, "0"); // pad with leading zero if necessary
  const formattedCurrentDate = `${currentYear}-${currentMonth}-${currentDay}`;
  const [startDate, setStartDate] = useState(formattedCurrentDate);
  const [beginRegistrationDate, setBeginRegsitrationDate] = useState(formattedCurrentDate);

  const nextDate = new Date();
  nextDate.setDate(currentDate.getDate() + 1);
  const nextYear = nextDate.getFullYear();
  const nextMonth = (nextDate.getMonth() + 1).toString().padStart(2, "0"); // add 1 to month because getMonth() returns 0-based index, and pad with leading zero if necessary
  const nextDay = nextDate.getDate().toString().padStart(2, "0"); // pad with leading zero if necessary
  const formattedNextDate = `${nextYear}-${nextMonth}-${nextDay}`;
  const [endDate, setEndDate] = useState(formattedNextDate);
  const [endRegistrationDate, setEndRegistrationDate] = useState(formattedNextDate);

  //dialog and snackbar
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const maxTitleLength = 100;
  const maxDescLength = 30000;

  useEffect(() => {
    if (minMembLvl != "" && minMembLvl != null) {
      setAllowedMembLvls(membershipLvls.slice(membershipLvls.indexOf(minMembLvl.toString())));
    } else {
      setAllowedMembLvls([]);
    }
  }, [minMembLvl]);

  useEffect(() => {
    const tempArray = [];
    for (let i = 0; i < membershipLvls.length; i++) {
      if (i < membershipLvls.indexOf(minMembLvl.toString()) ||
          membershipLvls.indexOf(minMembLvl.toString()) == -1) {
        tempArray[i] = "0";
      } else {
        tempArray[i] = maxContacts[i];
      }
    }
    setMaxContacts(tempArray);
  }, [minMembLvl]);

  const handleCreateEvent = (e, draft) => {
    if (minMembLvl == null) {
      setSnackbarMessage("Must specify a minimum partnership level");
      setSnackbarOpen(true);
      return;
    }

    //Ensure at least one maxContacts is greater than 0
    if(!maxContacts.some((mc) => mc > 0)) {
      alert("Cannot set maximum number of contacts to 0 for all partnership levels.");
      return;
    }

    const body = new FormData();
    body.append("event", eventTitle);
    body.append("description", description);
    body.append("startDate", startDate);
    body.append("endDate", endDate);
    body.append("beginRegistrationDate", beginRegistrationDate);
    body.append("endRegistrationDate", endRegistrationDate);
    body.append("expireDate", endDate);
    body.append("maxContacts", maxContacts);
    body.append("minMembershipLevelIndex", membershipLvls.indexOf(minMembLvl.toString()));

    axios.post("/events/createEvent", body).then((res) => {
      const data = res.data;
      if (data.success) {
        resetHooks();
        setOpenCreateDialog(false);
        setUpdateTable(!updateTable);
      } else {
        setSnackbarMessage(data.message);
        setSnackbarOpen(true);
      }
    });
  };

  const handleMaxContacts = (event, index) => {
    const tempArray = maxContacts.slice();
    tempArray[index] = event;
    setMaxContacts(tempArray);
  };

  const resetHooks = () => {
    setEventTitle("");
    setDescription("");
    setStartDate(formattedCurrentDate);
    setEndDate(formattedNextDate);
    setBeginRegsitrationDate(formattedCurrentDate);
    setEndRegistrationDate(formattedNextDate);
    setMinMembLvl("");
  };

  const maxContactsFields = allowedMembLvls.map((membershipLevel, index) => (
    <div className="MaxContacts" key={index}>
      <div className="EventCreate-maxContacts text-lg font-brand-primary">
        Maximum number of contacts for {membershipLevel} *
      </div>
      <CreateValidateTextField
        pattern="\d+"
        value={maxContacts[index+membershipLvls.length-allowedMembLvls.length]}
        setter={event => handleMaxContacts(event, membershipLvls.indexOf(membershipLevel))}
        errorMessage={"Invalid Number of Contacts."}
        required={true}
        maxLength={5} />
    </div>
  ));

  function showCreateDialog() {
    return (
      <Dialog open={openCreateDialog} maxWidth={false}>
        <DialogTitle className="EventCreate-title mx-auto text-2xl font-bold font-brand-primary">
          Create Event
        </DialogTitle>
        <div className="EventCreate-modalContainer flex w-fit mb-4 mx-4">
          <div className="EventCreate-modalLeftContainer flex flex-col w-fit">
            <div className="EventCreate-titleContainer flex flex-col w-96 mx-4 mb-2">
              <div className="EventCreate-title text-lg font-brand-primary">
                Event Title * {maxTitleLength - eventTitle.length} characters left
              </div>
              <CreateValidateTextField
                placeholder="Event Title"
                pattern="(?=.*\w).+"
                value={eventTitle}
                setter={setEventTitle}
                errorMessage={"Invalid Title."}
                required={true}
                maxLength={maxTitleLength}
              />
            </div>
            <div className="EventCreate-maxContactsContainer flex flex-col w-96 mx-4 mb-2">
              {maxContactsFields}
            </div>
            <div className="EventCreate-descContainer flex flex-col w-96 mx-4 mb-2">
              <div className="EventCreate-maxContacts text-lg font-brand-primary">
                Description * {maxDescLength - description.length} characters left
              </div>
              <textarea
                value={description}
                onChange={(event) => {
                  if (event.target.value.length <= maxDescLength) {
                    setDescription(event.target.value);
                  }
                }}
                className="rounded-xl bg-white p-2 border border-gray-300"
                type="textarea"
                placeholder="Event description"
                required={true}
              />
            </div>
            <div className="EventCreate-dateContainer flex justify-between">
              <div className="EventCreate-startDateContainer flex flex-col w-44 ml-4 mb-2">
                <div className="EventCreate-startDateTitle text-lg font-brand-primary">
                  Event Start Date *
                </div>
                <FilledInput
                  required
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  disableUnderline={true}
                  className="rounded-xl bg-white border border-gray-300 h-11 [&>input]:pt-2"
                />
              </div>
              <div className="EventCreate-endDateContainer flex flex-col w-44 mr-4 mb-2">
                <div className="EventCreate-endDateTitle text-lg font-brand-primary">
                  Event End Date *
                </div>
                <FilledInput
                  required
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  disableUnderline={true}
                  className="rounded-xl h-11 bg-white border border-gray-300 [&>input]:pt-2"
                />
              </div>
            </div>
          </div>
          <div className="EventCreate-modalRightContainer flex flex-col w-fit">
            <div className="EventCreate-membershipLvlContainer flex flex-col w-96 mx-4">
              <div className="EventCreate-JobLevelTitle text-lg font-brand-primary">
                Minimum partnership level required to attend: *
              </div>
              <div className="[&>div>div]:mb-2">
                <Multiselect
                  options={membershipLvls}
                  selectedValue={minMembLvl}
                  selectedSetter={setMinMembLvl}
                  multiStatus={false}
                />
              </div>
            </div>
            <div className="EventCreate-dateContainer flex justify-between">
              <div className="EventCreate-beginRegistrationDateContainer flex flex-col w-44 ml-4 mb-2">
                <div className="EventCreate-beginRegistrationDateTitle text-lg font-brand-primary">
                  Registration Start Date *
                </div>
                <FilledInput
                  required
                  type="date"
                  value={beginRegistrationDate}
                  onChange={(e) => setBeginRegsitrationDate(e.target.value)}
                  disableUnderline={true}
                  className="rounded-xl bg-white border border-gray-300 h-11 [&>input]:pt-2"
                />
              </div>
              <div className="EventCreate-endRegistrationDateContainer flex flex-col w-44 mr-4 mb-2">
                <div className="EventCreate-endRegistrationDateTitle text-lg font-brand-primary">
                  Registration End Date *
                </div>
                <FilledInput
                  required
                  type="date"
                  value={endRegistrationDate}
                  onChange={(e) => setEndRegistrationDate(e.target.value)}
                  disableUnderline={true}
                  className="rounded-xl h-11 bg-white border border-gray-300 [&>input]:pt-2"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="EventCreate-buttonContainer flex justify-between px-8 mb-4">
          {/* <button
            type="button"
            className="primary-button bg-brand-secondary mb-2 h-11 pt-3"
            onClick={(event) => handleCreateEvent(event, true)}
          >
            Save As Draft
          </button> */}
          <button
            type="button"
            className="primary-button bg-brand-quaternary mb-2 h-11 pt-3"
            onClick={(event) => handleCreateEvent(event, false)}
          >
            Create Event
          </button>
          {/* <button
            type="button"
            className="primary-button bg-brand-primary  mb-2 h-11 pt-3"
            onClick={resetHooks}
          >
            Reset
          </button> */}
          <button
            type="button"
            className="primary-button bg-brand-primary mb-2 h-11 pt-3"
            onClick={() => {
              setOpenCreateDialog(false);
              resetHooks();
            }}
          >
            Cancel
          </button>
        </div>
        <Snackbar
          open={snackbarOpen}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={6000}
          onClose={() => {
            setSnackbarOpen(false);
            setSnackbarMessage("");
          }
          }
        >
          <Alert
            onClose={() => {
              setSnackbarOpen(false);
              setSnackbarMessage("");
            }
            }
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Dialog>
    );
  }

  return (
    <div className="EventCreate-container">
      {showCreateDialog()}
      <button
        type="button"
        className="EventCreate-button search-button px-4 h-11 mb-4 mr-4 text-center py-2"
        onClick={() => setOpenCreateDialog(true)}
      >
        Create Event
      </button>
    </div>
  );
}

EventCreate.propTypes = {
  userType: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired,
  updateTable: PropTypes.bool.isRequired,
  setUpdateTable: PropTypes.func.isRequired,
  membershipLvls: PropTypes.array
};

EventCreate.defaultProps = {
  userType: "",
  username: "",
  updateTable: false,
  setUpdateTable: ()=>{},
  membershipLvls: []
};

export default EventCreate;
